import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      // Sign in
      'login': 'Log in',
      'logout': 'Log out',
      'signup': 'Sign up',
      'email': 'Email',
      'password': 'Password',
      'forgot_password': 'Forgot password',
      'you_can_use': 'You can use',
      'and_password': 'and password',
      'username': 'Username',
      // Navbar
      'navbar_new_project': 'New project',
      'navbar_app_settings': 'App settings',
      'toast_language_changed': 'Language changed',
      'view_all': 'View all',
      'new_project': 'New project',
      // General
      'unaddressed': 'Unaddressed',
      'quick_and_dirty': 'Quick and dirty',
      'advanced': 'Advanced',
      'reliable': 'Reliable',
      'save': 'Save',
      'invite': 'Invite',
      'members': 'Members',
      'name': 'Name',
      'role': 'Role',
      'actions': 'Actions',
      'view': 'View',
      'edit': 'Edit',
      'duplicate': 'Duplicate',
      'remove': 'Remove',
      'delete': 'Delete',
      'delete_team_member': 'Delete Team Member',
      'confirm_delete_member_message': 'Are you sure you want to remove',
      'confirm_delete_document': 'Are you sure you want to delete',
      'confirm_delete_item': 'Are you sure you want to delete this item? This action cannot be undone.',
      'account_change_email': 'Change email',
      'account_email_change_sent': 'Confirmation email sent',
      'account_email_change_pending': 'A confirmation link was sent to {{email}}. Your address stays {{current}} until you open it.',
      'account_email_change_error': 'Error on saving. Please try again',
      'account_email_confirm_missing_token': 'Missing confirmation token in URL.',
      'account_email_confirm_invalid': 'This confirmation link is invalid or has expired.',
      'account_email_confirm_unchanged': 'Your email address has not been changed. You can request a new link from your account page.',
      'account_email_confirm_back': 'Back to my account',
      'account_email_confirm_done': 'Your email address is now {{email}}.',
      'account_email_confirm_use_it': 'Use it to sign in from now on.',
      'account_email_confirm_go_signin': 'Go to sign in',
      'account_email_confirm_working': 'Confirming your new email address…',
      'delete_member_warning': 'This action cannot be undone.',
      'deleting': 'Deleting...',
      'description': 'Description',
      'review_max': 'Review max',
      'admin_space': 'Admin space',
      'editor': 'Editor',
      'viewer': 'Viewer',
      'not_allowed': 'Not allowed',
      'cancel': 'Cancel',
      'send_invitation': 'Send invitation',
      'add': 'Add',
      'created_at': 'Created on',
      'modified_at': 'Last modification',
      'update': 'Update',
      'create': 'Create',
      'save_and_new': 'Save and create new',
      'power_of_this_stakeholder': 'Power of this Stakeholder',
      'aspirations_resistances_of_this_stakeholder': 'Aspirations & Resistances of this Stakeholder',
      'influencing_this_stakeholder': 'Influencing this Stakeholder',
      'impact_of_this_factor': 'Impact of this Factor',
      'mitigation_of_this_factor': 'Mitigation of this Factor',
      'importance_of_this_factor': 'Importance of this Factor',
      'unknown_importance_label': 'Importance of this Unknown',
      'unknown_save_label': 'Save',
      'unknown_save_and_new_label': 'Save and Create New One',
      'unknown_save_error': 'The Unknown could not be saved. Please try again.',
      'not_concerned': 'Not concerned',
      'not_important': 'Not important',
      'important': 'Important',
      'very_important': 'Very important',
      'critical': 'Critical',
      'not_provided': 'Not provided',
      'poor': 'Poor',
      'fair': 'Fair',
      'good': 'Good',
      'outstanding': 'Outstanding',
      'report': 'Report',
      'feasibility_study': 'Opportunity case',
      'gantt_chart': 'Gantt chart',
      'tools': 'Tools',
      'go_to': 'Go to',
      'review_1_customers': 'Review 1 : Customers',
      'review_1_customer_fit': 'Review 1 : Customer Fit',
      'review_1_company_fit': 'Review 1 : Decision Maker Fit',
      'do_you_want_to_close_without_saving': 'You are about to exit this window: please choose one of the following options',
      'confirmation_title': 'Confirmation',
      'confirmation': 'Confirmation',
      'alternative_name': 'Alternative name',
      'hide_details': 'Hide details',
      'show_details': 'Show details',
      'is_constraint': 'Constraint',
      'all_plans': 'All plans',
      'presentation': 'Tutorial',
      'tutorial': 'Tutorial',
      'report_a_bug': 'Report a bug',
      'plan': 'Subscription',
      // Organization
      'organization': 'Organization',
      'subscription': 'Subscription',
      'premium_plan': 'Premium plan',
      'free_plan': 'Free plan',
      'last_update_label': 'Last update',
      'unknowns_count_label': 'Unknowns',
      'actions_count_label': 'Actions',
      'general': 'General',
      'organization_settings': 'Organization settings',
      'settings': 'Settings',
      'organization_name': 'Organization name',
      'company_size': 'Company size',
      'team_name': 'Team name',
      // Project
      'project_administration': 'Project administration',
      'people': 'People',
      'add_team_member': 'Add team member',
      'add_validator': 'Add validator',
      'add_key_player': 'Add key player',
      // Account
      'account': 'Account',
      'projects': 'Projects',
      'reports': 'Reports',
      'overview': 'Overview',
      'sales': 'Sales',
      'general_settings': 'General settings',
      'notifications': 'Notifications',
      'team': 'Team',
      'billing': 'Billing',
      'project': 'Project',
      'whole_project': 'Whole Project',
      'project_settings': 'Project settings',
      'project_team': 'Project team',
      // Review 1
      'customer': 'Customer',
      'review_1': 'Hope?',
      'customers': 'Customers',
      'company_fit': 'Investors & Companies',
      'update_customer': 'Update customer',
      'create_customer': 'Create customer',
      'customer_deletion': 'Customer deletion',
      'customer_deletion_message': 'Are you sure to delete this customer?',
      'pnd': 'Pain / Need / Desire',
      'benchmarking': 'Benchmarking',
      'experience': 'Experience',
      'who_is_the_customer': 'Who is the costumer?',
      'customer_issue_problem': 'What is the customer\'s issue/problem?',
      'price_per_unit': 'Price per unit',
      'unit': 'Unit',
      'target_market_comments': 'Target market comments',
      'decision_criteria': 'Decision criteria',
      'importance': 'Importance',
      'focus': 'Focus',
      'criteria_name': 'Criteria name',
      'elevator_pitch_label': 'Elevator pitch for this customer',
      'cue_statement_label': 'Customer Unique Experience for this customer',
      'cue_statement_hint_label': 'Continue the statement starting with "I/we recommend this ... because it is the only one that ..."',
      'reason_to_buy_label': 'What is the compelling reason for this customer to buy?',
      'estimated_cost_and_price_label': 'Estimated Cost & Price',
      'cue_comments_label': 'Comments about our ability to deliver this Customer Unique Experience (including availability of technical or other capabilities)',
      'pre_con_cue_label': 'What are the prerequisites or conditions required for this CUE to work?',
      'cue_resitances_label': 'Outline all possible Resistances that this customer could raise in response to this CUE statement',
      'market_penetration_strategy_experience_label': 'Special characteristics of the market penetration strategy to reach this customer',
      'wow_label': 'What is the "Wow" for this customer?',
      'selling_price': 'Seling price',
      'estimated_cost': 'Estimated cost',
      'profit_margin': 'Profit margin',
      'benefits': 'Benefits',
      'benefits_for_our_company_label': 'Benefits for our company',
      'brand_essence_compatibility_label': 'Compatibility with Brand essence',
      'concerned_divisions_label': 'Concerned divisions',
      'confidence_indice_label': 'confidence_indice_label',
      'corporate_mission_label': 'Which components of our corporate mission will benefit from seizing this opportunity?',
      'geographical_scope_label': 'Geographical scope (Territory)',
      'get_results_by_label': 'Get results by',
      'kpi_benefit_label': 'Which of our corporate Key Performance Indicators will be improved by seizing this opportunity?',
      'launch_date_label': 'Launch date',
      'market_size_label': 'Market size',
      'consequences_on_failure_label': 'Consequences of premature project termination or failure',
      'not_seizing_opportunity_label': 'What will happen if our company does not seize this opportunity?',
      'strategic_fit_label': 'Strategic fit',
      'target_audience_label': 'Target audience',
      'company': 'Investor/Company',
      'pre_requisites': 'Pre-requisites',
      'client_aspiration': 'Client aspiration',
      'days_ago': 'day(s) ago',
      'why_not_implemented_label': 'Why this Solution has not yet been implemented?',
      'skills_required_label': 'What skills are required to implement this Solution?',
      'number_of_customers_label': 'Number of Customers with the same buying profile defined by Customer Decision Criteria',
      'turnover_generated_label': 'Turnover that all customers with this profile can generate (Market size for this customer)',
      'market_penetration_label': 'Your market penetration: number of customers with this profile that you can reach',
      'market_penetration_strategy_label': 'Special characteristics of the Penetration Strategy (how you will reach these Customers)',
      'update_company': 'Update company or investor',
      'create_company': 'Create company or investor',
      // Review 2
      'review_2': 'Worth it?',
      'definition_of_success_and_failure': 'Definition of Success & Failure',
      'milestones': 'Milestones',
      'kiss': 'Key Indicators of Success (KISs)',
      'terminators': 'Key Indicators of Failures (Terminators)',
      'activity_chain': 'Activity chain',
      'customer_relationships_strategies': 'Special characteristics of the Customer Relationships strategy',
      'marketing_strategies': 'Special characteristics of the Marketing strategy',
      'distribution_strategies': 'Special characteristics of the Distribution strategy',
      'product_development_strategies': 'Special characteristics of the  Product Development strategy',
      'production_strategies': 'Special characteristics of the Production strategy',
      'service_strategies': 'Special characteristics of the Service strategy',
      'ip_strategies': 'Special characteristics of the I.P. strategy',
      'procurement_strategies': 'Special characteristics of the Procurement strategy',
      'infrastructure_strategies': 'Special characteristics of the Service strategy',
      'partnering_strategies': 'Special characteristics of the Partnering strategy',
      'hr_strategies': 'Special characteristics of the H.R. strategy',
      'training_strategies': 'Special characteristics of the Training strategy',
      'financial_strategies': 'Special characteristics of the Financial strategy',
      'change_of_processes_strategies': 'Special characteristics of the Change of processes strategy',
      'change_management_strategies': 'Special characteristics of the Change management strategy',
      'economic_model': 'Generation of Resources',
      'review_2_economic_model': 'How will project obtain recurrent resources?',
      'kiss_field': 'Kiss',
      'terminator_field': 'Terminator',
      'mechanism': 'Mechanism',
      'target': 'Target',
      'what': 'What',
      'comment': 'Comment',
      'skills': 'Skills',
      'benefit': 'Benefit',
      'day_per_man': 'Day per man',
      'percentage_available': 'Percentage available',
      // Review 3
      'review_3': 'Influencers?',
      'probability': 'Probability',
      'confidence_level': 'Confidence level',
      'opportunity_killer': 'Magnitude',
      'neg_impact': 'Negative impact',
      'pos_impact': 'Positive impact',
      'pre_move': 'Pre. action',
      'cont_move': 'Cont. action',
      'low': 'Low',
      'medium': 'Medium',
      'high': 'High',
      'no': 'No',
      'yes': 'Yes',
      'preventive_move': 'Preventive action',
      'contigency_move': 'Contengency action',
      'concerning': 'Concerning',
      'update_and_quit': 'Update & quit',
      'add_factor': 'Add factor',
      'create_factor': 'Create factor',
      'update_factor': 'Update factor',
      'add_stakeholder': 'Add stakeholder',
      'add_investor': 'Add investor',
      'update_stakeholder': 'Update stakeholder',
      // Review 4
      'review_4': 'How?',
      'launch_plan': 'Launch plan',
      'reduce_unknowns_plan': 'Reduce unknowns plan',
      'intellectual_properties': 'Intellectual property',
      'moves': 'Actions',
      'add_move': 'Add action',
      'add_intellectual_property': 'Add intellectual property',
      'consultant': 'Consultant',
      'it': 'I.T.',
      'timeline': 'Timeline',
      'budget_summary': 'Budget summary',
      // Quick Actions
      // // Unknown
      'create_unknown': 'Create unknown',
      'concerning_id': 'Concerning ID',
      'positive_impact': 'Positive impact',
      'negative_impact': 'Negative impact',
      'no_go': 'No go',
      'criticality': 'Impact',
      'impact': 'Impact',
      'add_tactical_move': 'Add tactical action',
      'create_and_quit': 'Create and quit',
      'create_and_add_another_one': 'Create and add another one',
      'collateral_effects': 'Potential Collateral Effects',
      'collateral_stakeholder': 'Stakeholders impacted by this Collateral effect',
      'collateral_severity': 'Level of severity of this collateral effect',
      'resources': 'Resources',
      'action_plan': 'Action plan',
      'stakeholders': 'Stakeholders',
      'factors': 'Factors',
      'factor_name': 'Factor Name',
      'description_of_this_factor': 'Description of this Factor',
      'scope': 'Scope',
      'company_decision_criteria': 'Company decision criteria',
      'solution': 'Solution',
      'solution_name': 'Solution name',
      'solution_description': 'Detailed description of the solution/project',
      'geographic_scope': 'Geographic scope',
      'proof_of_concept_date': 'Proof of concept date',
      'demonstration_date': 'Demonstration date',
      'pilot_beginning_date': 'Pilot beginning date',
      'pilot_end_date': 'Pilot end date',
      'launch_date': 'Launch date',
      'customer_benchmarking': 'Customer benchmarking',
      'customer_knowledge': 'Customer knowledge',
      'customer_pnds': 'Customer PNDs',
      'add_unknown': 'Add unknown',
      'update_unknown': 'Update unknown',
      // // Move
      'create_move': 'Create Action',
      'essentials': 'Essentials',
      'more_details': 'More details',
      'costing': 'Costing',
      'detailed_impact': 'Detailed impact',
      'selected_for_action_plan': 'Selected for action plan',
      'retained_for_action_plan': 'Retained for final Action Plan',
      'selected_for_launch_plan': 'Selected for launch plan',
      'selected_for_reduce_unknown_plan': 'Selected for reduce unknown plan',
      'decision_for_action_plan': 'Recommendation for Action plan',
      'must_be_done': 'Must be done',
      'should_be_done': 'Should be done',
      'nice_to_do': 'Nice to do',
      'not_worth_it': 'Not worth it',
      'manage_stakeholders': 'Manage stakeholders',
      'fit_company': 'Investor/Company Fit',
      'reduce_resitances': 'Reduce resistances',
      'reduce_unknowns': 'Reduce unknonwns',
      'reduce_constraints': 'Reduce constraints',
      'reduce_risks': 'Reduce risks',
      'overcome_obstacles': 'Overcome obstacles',
      'benefit_of_boosters': 'Benefit of boosters',
      'create_barrier_to_entry': 'Create barrier to entry',
      'deliver_benefits': 'Deliver benefits',
      'convince_customers': 'Convince customers',
      'increase_market_penetration': 'Increase market penetration',
      'obtain_the_resource': 'Obtain the resource',
      'reduce_collateral_effect': 'Reduce collaterial effect',
      'support_the_team': 'Support the team',
      'start_date': 'Start date',
      'end_date': 'End date',
      'user': 'User',
      'back': 'Back',
      'next_step': 'Next step',
      'description_of_the_move': 'Detailed description of the Action',
      'action_name': 'Action name',
      'comment_about_action': 'Comment about the Action',
      'collateral_effects_action': 'Collateral effects triggered by this Action',
      'estimated_total_cost_action': 'Estimated total cost of this Action',
      'kpi': 'Key Indicators of Performance (KPI)',
      'goal_date': 'Goal date',
      'description_of_the_goal': 'Description of the goal',
      'units': 'Units',
      'amount_per_unit': 'Amount / Unit',
      'workingCapital': 'Working capital',
      'equipmentCost': 'Equipment cost',
      'consultants': 'Consultants fees',
      'subcontractors': 'Subcontractors Remuneration',
      'travelExpenses': 'Travel expenses',
      'seniorManagement': 'Senior management',
      'intermediateManagement': 'Intermediate management',
      'engineering': 'Engineering',
      'admin': 'Admin',
      'production': 'Production',
      'space': 'Space',
      'total': 'Total',
      'definition_of_success': 'Definition of success',
      'definition_of_failure': 'Definition of failure',
      'client_decision_criteria': 'Client decision criteria',
      'unknowns': 'Unknowns',
      'list_of_unknowns': 'List of Unknowns',
      'obstacles': 'Obstacles',
      'risks': 'Risks',
      'boosters': 'Boosters',
      'constraints': 'Constraints',
      'resistances': 'Resistances',
      'aspirations': 'Pain/Need/Desire(s) (= Aspiration(s))',
      'all_steps_completed': 'All steps completed !',
      'update_move': 'Update Action',
      'planning': 'Planning',
      'move_details': 'Costing of this Action',
      // // IP
      'create_intellectual_property': 'Create intellectual property',
      'unique_feature': 'Unique feature',
      'current_best_mode': 'Current best mode',
      'persons': 'Persons',
      'prior_art_description': 'Prior art description',
      'closest_publication': 'Closest publication',
      // // Comment
      'create_comment': 'Create comment',
      'update_comment': 'Update Comment',
      'comment_created': 'Comment created',
      'comment_updated': 'Comment updated',
      'message': 'Message',
      'share_with_team': 'Share with team',
      'upload_private_label': 'Private upload for me',
      'upload_shared_label': 'Upload shared with the project team',
      'private': 'Private',
      'shared': 'Shared',
      'shared_private': 'Shared / Private',
      'comment_filter_all': 'All',
      'comment_filter_private': 'Private',
      'comment_filter_shared': 'Shared',
      'comments': 'Comments',
      'link': 'Link',
      'url': 'URL',
      'review_3_stakeholders': 'Review 3 : Stakeholders',
      // // Document
      'add_file_or_url': 'Add File or URL',
      'upload_file_or_url': 'Upload File or URL',
      'name_of_upload': 'Name of Upload',
      'description_of_upload': 'Description of Upload',
      'title': 'Title',
      // // Stakeholders
      'create_stakeholder': 'Create stakeholder',
      'profile': 'Profile',
      'lever': 'Aspirations/Resistances',
      'stakeholder_name': 'Stakeholder Name',
      'influencing': 'Influence',
      'level_of_power': 'Level of power',
      'level_of_support': 'Level of support',
      'level_of_support_of_this_stakeholder': 'Level of Support of this Stakeholder',
      'level_of_support_info': 'How supportive this stakeholder is of the project. Use the toggle below to record whether this level has been verified.',
      'level_of_support_verified_switch': 'The Level of Support has been Verified',
      'how_impacted': 'How impacted',
      'how_impacted_by_project': 'How this Stakeholder is Impacted by this Project',
      'influencing_who': 'Can influence',
      'influencing_by': 'Is influenced by',
      'stakeholder_benefits': 'Benefits for this stakeholder derived from the Solution',
      'stakeholder_collateral_damages': 'Collateral Damage(s) that this Stakeholder could Experience',
      'aspirations_label': 'Aspiration',
      'resistances_label': 'Resistance',
      'this_stakeholder': 'This Stakeholder',
      // Logs
      'customer_pnd': 'PND',
      'customer_experience': 'Solution / Experience',
      'company_benefits': 'Benefits',
      // Reports
      'feasibility_studies': 'Opportunity cases',
      'gantt_charts': 'Gantt charts',
      'create_new_version': 'Create new version',
      'executive': 'Executive',
      'complete': 'Complete',
      // LABELS
      'concerning_label': 'Concerning',
      'reduced_by': 'Move to reduce',
      'probability_label': 'Probability',
      'move_description': 'Action description',
      'selected': 'Selected',
      'start': 'Start',
      'end': 'End',
      'create_bug_report': 'Please share to us bugs and improvements',
      // INFO
      'info_short_text_6': 'What are Customers?',
      'info_long_text_6': 'Customers are potential users/adopters of a proposed product/solution. These can be individuals or businesses. A product/solution must have at least one customer type, but will most likely have multiple. Different customer types will have different experiences with the product/solution and will have different expectations and requirements. (i.e., Credit Cards have 3 different types of customers: 1. Credit Card users that use the product to purchase goods and/or services; 2.  Businesses that use Credit Cards to sell their goods and/or services; 3. Banks that sell credit cards to their customers.',
      'info_short_text_7': 'Add all the potential customer types that your solution/product may have',
      'info_short_text_8': 'Add an Unknown',
      'info_short_text_9': 'Add a Stakeholder',
      'info_short_text_10': 'Add a Factor',
      'info_short_text_11': 'Add an Action',
      'info_short_text_12': 'Add Intellectual Property',
      'info_short_text_17': 'Does this solution match your Company/Investor\'s strategy & culture?',
      'info_long_text_17': 'How does this product/solution fit your company/investors strategy from a business and brand perspective? Does it fit the company/investor\'s culture? Will it cannibalize an existing product/solution? How will it impact existing teams and resources? How will it impact existing customers and providers? Etc.',
      'info_short_text_32': 'Add Alternative Solutions or competitors addressing the same PNDs',
      'add_milestone_tooltip': 'Add new milestone',
      'info_short_text_X': '',
      'info_long_text_X': '',
      // WELCOME MESSAGE
      'wm_the_ipop_tools': 'The IpOp Tools',
      'wm_the_ipop_reviews': 'The IpOp Reviews',
      'wm_quick_actions_buttons': 'Quick Actions Buttons',
      'wm_best_practices': 'Best Practices',
      'wm_video_tutorials': 'Video Tutorials',
      'video_tutorial': 'Video tutorial',
      'video_followup_title': 'Continue with the next tutorials',
      'video_followup_subtitle': 'Pick any tutorial below to keep learning.',
      'video_not_uploaded_yet': 'This video has not been uploaded yet. Please come back later.',
      'watch_video': 'Watch video',
      'dont_show_again': 'Do not Show Again',
      'close': 'Close',
      // PDF
      'empty_fields': 'Empty Fields',
      'hidden_fields': 'Hidden Fields',
      'deactivated': 'Deactivated',
      'deactivated_pages': 'Pages that have been deactivated',
      'deactivated_fields': 'Fields that have been deactivated',
      'deactivate_field': 'Deactivate this field',
      'deactivate_page': 'Deactivate this page',
      'reply': 'Reply',
      'send': 'Send',
      'add_comment': 'Add comment',
      'no_comments': 'No comments yet',
      'documents_on_this_page': 'Documents on this page',
      'list_of_uploads_for': 'List of uploads for {{screen}}',
      'documents': 'Documents',
      'uploads': 'Uploads',
      'type': 'Type',
      'file': 'File',
      'no_documents': 'No uploads yet',
      'upload_created': 'Upload created',
      'url_helper_text': 'Or paste a link to an external document',
      'invalid_url': 'Invalid URL',
      'estimated_price': 'Estimated price',
      'alternatives': 'Alternatives',
      'company_alternatives': 'Company alternatives',
      'milestone_due_date': 'Milestone due date',
      'milestone_definition': 'Milestone definition',
      'kiss_name': 'Key Indicator of Success name',
      'kiss_unit': 'Unit',
      'kiss_value': 'Key Indicator value (per milestone)',
      'kif_name': 'Key Indicator of Failure name',
      'kif_value': 'Key Indicator of Failure value (per milestone)',
      'terminators_consequences': 'Terminators consequences',
      'investors': 'Investors',
      'investor_benefits': 'Investor benefits',
      'power_support_map': 'Power vs Support map',
      'search_action_name': 'Search action name',
      'view_toggle': 'View toggle',
      'concernings_label': 'Concernings',
      'search_ip_description': 'Search intellectual property description',
      'plan_type_budget': 'Budget plan selection',
      'other': 'Other',
      'reactivate': 'Reactivate',
      'hidden_fields_on_this_page': 'Hidden fields on this page',
      'add_tactical_action': '+ Tactical action',
      'select_resistance_actions': 'Select Tactical Actions',
      'selected_resistance_actions': 'Selected Tactical Actions',
      'no_deactivated_items': 'Nothing has been deactivated yet',
      'field': 'Field',
      'page': 'Page',
      'lists': 'Lists',
      'show_current_version': 'Show current version',
      'export_print': 'Export / Print',
      'view_report': 'View report',
      'download': 'Download',
      'export_all_uploads': 'Export all',
      'new_version': 'New Version',
      // OTHER
      'alignement': 'Investor Alignment',
      'pilot_details': 'Details of the Pilot',
      'pilot_expected_outcomes': 'Expected Outcomes of this Pilot',
      'pilot_start_date': 'Start Date of the Pilot',
      'pilot_end_date_label': 'End Date of the Pilot',
      'investor_benefits_tab': 'Single Investor Benefits',
      'all_benefits_tab': 'All Benefits',
      'investor_benchmarking_tab': 'Investor Benchmarking',
      'strategic_fit': 'Strategic fit',
      'concerned_divisions': 'Concerned divisions',
      'potential_synergies': 'Potential synergies',
      'risk_of_canibalization': 'Risk of canibalization',
      'constrains': 'Constrains',
      'biggest_challenges': 'Biggest challenges',
      'brand_essence_compatibility': 'Brand essence compatibility',
      'geographical_scope': 'Geographical scope',
      'target_audience': 'Target audience',
      'wow': 'Wow effect',
      'potential_evolution': 'Potential evoluation',
      'worth_it': 'Worth it?',
      'estimated_chance_of_success': 'Estimated chance of success',
      'when_poc': 'When launch proof of concept',
      'demonstration_be_made': 'When demonstration be made',
      'wow_investor_alignment_label': "Which 'Wow' Factor for this Investor",
      'worth_it_investor_alignment_label': 'What makes this opportunity worth it for this Investor',
      'estimated_chance_of_success_investor_alignment_label': 'Estimated Chances of Success for this Investor',
      'strategic_fit_investor_alignment_label': 'Fit with the Strategy of this Investor',
      'concerned_divisions_investor_alignment_label': 'Concerned Division(s) for this Investor',
      'potential_synergies_investor_alignment_label': 'Potential Synergies for this Investor',
      'risk_of_canibalization_investor_alignment_label': 'Risk of Canibalization of this Investor Offering',
      'biggest_challenges_investor_alignment_label': 'Biggest Challenges for this Investor',
      'constrains_investor_alignment_label': 'Constraints imposed by this Investor',
      'brand_essence_compatibility_investor_alignment_label': 'Compatibility with this Investor Brand Essence',
      'geographical_scope_investor_alignment_label': 'Geographical scope',
      'target_audience_investor_alignment_label': 'Target audience',
      'potential_evolution_investor_alignment_label': 'Potential Evolution or Expansion for this Investor',
      'when_poc_investor_alignment_label': 'When this Investor Can See a Proof of Concept',
      'demonstration_be_made_investor_alignment_label': 'When this Investor Can See a Demonstration',
      'certain': 'Certain',
      'for_sure': 'For sure',
      'minor': 'Minor',
      'version': 'Version',
      'target_reader': 'Target reader',
      'requested_decision': 'Requested decision',
      'current_stage': 'Current stage',
      'next_steps': 'Next steps',
      'validations': 'Validations',
      'Tactical Actions to reduce this Unknown': 'Tactical Actions to reduce this Unknown',
      'No actions selected': 'No actions selected',
      'Result of Action to reduce Unknown (what has been learned)': 'Result of Action to reduce Unknown (what has been learned)',
      'Select Contingency Actions': 'Select Contingency Actions',
      'Selected Contingency Actions': 'Selected Contingency Actions',
      'Select Preventive Actions': 'Select Preventive Actions',
      'Selected Preventive Actions': 'Selected Preventive Actions',
      'Select Booster Actions': 'Select Booster Actions',
      'Selected Booster Actions': 'Selected Booster Actions',
      'Actions to Prevent this Risk from Happening': 'Actions to Prevent this Risk from Happening',
      'Actions Addressing Risk when it Materializes': 'Actions Addressing Risk when it Materializes',
      'Actions to Take Advantage of a Booster (Positive Factor)': 'Actions to Take Advantage of a Booster (Positive Factor)',
      'No preventive actions selected': 'No preventive actions selected',
      'No contingency actions selected': 'No contingency actions selected',
      'No booster actions selected': 'No booster actions selected',
      'Search actions...': 'Search actions...',
      'Select Related Actions': 'Select Related Actions',
      'Selected actions': 'Selected actions',
      'Choose existing actions that are related to this unknown. You can search by name, description, or comments.': 'Choose existing actions that are related to this unknown. You can search by name, description, or comments.',
      // Pending invitations
      'pending_invitations': 'Pending Invitations',
      'pending': 'Pending',
      'invited_as': 'Invited as',
      'permissions': 'Permissions',
      'invited_on': 'Invited on',
      'accept': 'Accept',
      'decline': 'Decline',
      'no_pending_invitations': 'No pending invitations',
      'no_pending_invitations_description': 'You have no pending project invitations at the moment.',
      'refresh': 'Refresh',
      'failed_to_load_pending_invitations': 'Failed to load pending invitations',
      'invitation_accepted_successfully': 'Invitation accepted successfully!',
      'failed_to_accept_invitation': 'Failed to accept invitation',
      'failed_to_process_invitation': 'Failed to process invitation',
      'invitation_declined_successfully': 'Invitation declined successfully!',
      'failed_to_decline_invitation': 'Failed to decline invitation',
      'premium_subscription_required_message': 'You need a premium subscription to accept project invitations. Please upgrade your plan to join projects.',
      'loading': 'Loading...',
      'premium_subscription_required_tooltip': 'Premium subscription required to accept invitations',
      'editor_full_access': 'Editor (full access)',
      'viewer_read_only': 'Viewer (read only)',
      'restricted_no_admin': 'Restricted (no admin access)',
      'team_member': 'Team member',
      'unknown': 'Unknown',
      'edit_team_member': 'Edit team member',
      'member_permissions_updated_successfully': 'Member permissions updated successfully',
      'failed_to_update_member_permissions': 'Failed to update member permissions',
      'invite_team_member': 'Invite Team Member',
      'invitation_sent_successfully': 'Invitation sent successfully',
      'failed_to_send_invitation': 'Failed to send invitation',
      'premium_subscription_required_invite': 'Premium subscription required to invite team members. Please upgrade your plan.',
      'premium_subscription_required_send': 'Premium subscription required to send invitations. Please upgrade your plan.',
      'synthesis': 'Synthesis',
      'screen': 'Screen',
      'comment_title': 'Comment title',
      'author': 'Author',
      'date': 'Date',
      'importance_not': 'Not important',
      'importance_important': 'Important',
      'importance_very': 'Very important',
      'status': 'Status',
      'open': 'Open',
      'completed': 'Completed',
      'mark_completed': 'Archive this comment',
      'mark_open': 'Make Current',
      'current_comments': 'Current Comments',
      'archive_comment': 'Archive this comment',
      'unarchive_comment': 'Make Current',
      'comment_status_current': 'Current',
      'comment_status_archived': 'Archived',
      'comment_share_my_private': 'My Private Comments',
      'comment_share_shared': 'Shared Comments',
      'comment_url_label': 'Paste an optional link to a website/page or an external document',
      'comment_private_label': 'Private comment for me',
      'comment_shared_label': 'Comment shared with the project team',
      'nested': 'Nested',
      'conversation': 'Conversation',
      'all': 'All',
      'not_assessed': 'Not assessed',
      'respondent': 'Respondent',
      'validation_sent_title': 'Validation request sent',
      'validation_anti_spam_notice': 'Your validation request has been sent. To avoid it being treated as spam, please warn your validators that a legitimate request will come from No-reply@ipoptools.com. You can also forward them your own copy so they expect it.',
      'ok': 'OK',
      'failed_to_send_invitation_email': 'Failed to send invitation email. Please check the email address and try again.',
      'you_need_premium_subscription': 'You need a premium subscription to invite team members to your projects. Please upgrade your plan to enable team collaboration features.',
      'upgrade_subscription': 'Upgrade Subscription',
      'upgrade_now': 'Upgrade now',
      'subscription_limit_reached': 'Free tier limit reached: maximum {{limit}} items. Upgrade to Premium for unlimited access.',
      'must_be_valid_email': 'Must be a valid email',
      'email_is_required': 'Email is required',
      'active': 'Active',
      'waiting': 'Waiting',
      'rejected': 'Rejected',
      'deleted': 'Deleted',
      'required': 'Required',
      // Company — AI provider (bring your own LLM API key)
      'company_llm_section_title': 'AI provider',
      'company_llm_intro': 'Run the AI features on your own Anthropic or OpenAI account instead of ours. Your provider bills you directly for the usage.',
      'company_llm_default_notice': 'No provider is active: the AI features use our own key and draw on your included AI credits.',
      'company_llm_anthropic_key': 'Anthropic API key',
      'company_llm_openai_key': 'OpenAI API key',
      'company_llm_key_helper': 'Leave empty to keep the saved key. A saved key is never displayed again.',
      'company_llm_key_configured': 'Key saved',
      'company_llm_key_not_configured': 'No key saved',
      'company_llm_use_anthropic': 'Use our Anthropic account',
      'company_llm_use_openai': 'Use our OpenAI account',
      'company_llm_exclusive_hint': 'Only one provider can be active at a time — turning one on turns the other off.',
      'company_llm_enable_needs_key': 'Save a key first to activate this provider.',
      'company_llm_save': 'Save AI provider settings',
      'company_llm_saved': 'AI provider settings saved',
      'company_llm_save_error': 'Could not save the AI provider settings. Please try again.',
      'company_llm_no_company': 'Save your company information first to configure an AI provider.',
      // Assistant chat widget — shown instead of the credit balance
      'chat_own_api_key': 'Custom API key',
    }
  },
  fr: {
    translation: {
      // Sign in
      'login': 'Se connecter',
      'logout': 'Se déconnecter',
      'signup': 'S\'inscrire',
      'email': 'Email',
      'password': 'Mot de passe',
      'forgot_password': 'Mot de passe oublié',
      'you_can_use': 'Vous pouvez utiliser',
      'and_password': 'et le mot de passe',
      // Navbar
      'navbar_new_project': 'Nouveau projet',
      'navbar_app_settings': 'Paramètres',
      'toast_language_changed': 'La langue a changé',
      // General
      'save': 'Sauvegarder',
      'invite': 'Inviter',
      'members': 'Membres',
      'name': 'Nom',
      'role': 'Rôle',
      'actions': 'Actions',
      'view': 'Consulter',
      'edit': 'Modifier',
      'duplicate': 'Dupliquer',
      'remove': 'Supprimer',
      'delete': 'Supprimer',
      'delete_team_member': 'Supprimer un membre de l\'équipe',
      'confirm_delete_member_message': 'Êtes-vous sûr de vouloir supprimer',
      'confirm_delete_document': 'Êtes-vous sûr de vouloir supprimer',
      'confirm_delete_item': 'Êtes-vous sûr de vouloir supprimer cet élément ? Cette action ne peut pas être annulée.',
      'account_change_email': "Changer l'adresse email",
      'account_email_change_sent': 'Email de confirmation envoyé',
      'account_email_change_pending': "Un lien de confirmation a été envoyé à {{email}}. Votre adresse reste {{current}} tant que vous ne l'avez pas ouvert.",
      'account_email_change_error': "Erreur lors de l'enregistrement. Veuillez réessayer",
      'account_email_confirm_missing_token': "Jeton de confirmation absent de l'URL.",
      'account_email_confirm_invalid': 'Ce lien de confirmation est invalide ou a expiré.',
      'account_email_confirm_unchanged': "Votre adresse email n'a pas été modifiée. Vous pouvez demander un nouveau lien depuis votre page de compte.",
      'account_email_confirm_back': 'Retour à mon compte',
      'account_email_confirm_done': 'Votre adresse email est désormais {{email}}.',
      'account_email_confirm_use_it': 'Utilisez-la pour vous connecter à partir de maintenant.',
      'account_email_confirm_go_signin': 'Aller à la connexion',
      'account_email_confirm_working': 'Confirmation de votre nouvelle adresse email…',
      'delete_member_warning': 'Cette action ne peut pas être annulée.',
      'deleting': 'Suppression...',
      'description': 'Description',
      'review_max': 'Revue max',
      'team_name': 'Nom d\'équipe',
      'admin_space': 'Espace Admin',
      'editor': 'Éditeur',
      'viewer': 'Lecture seule',
      'not_allowed': 'Pas autorisé',
      'cancel': 'Annuler',
      'send_invitation': 'Envoyer l\'invitation',
      'add': 'Ajouter',
      'created_at': 'Créé le',
      'modified_at': 'Modifié le',
      'update': 'Mettre à jour',
      'create': 'Créer',
      'save_and_new': 'Enregistrer et créer un nouveau',
      'power_of_this_stakeholder': 'Pouvoir de cette partie prenante',
      'aspirations_resistances_of_this_stakeholder': 'Aspirations et résistances de cette partie prenante',
      'influencing_this_stakeholder': 'Influence de cette partie prenante',
      'impact_of_this_factor': 'Impact de ce facteur',
      'mitigation_of_this_factor': 'Atténuation de ce facteur',
      'importance_of_this_factor': 'Importance de ce facteur',
      'unknown_importance_label': 'Importance de cet inconnu',
      'unknown_save_label': 'Enregistrer',
      'unknown_save_and_new_label': 'Enregistrer et en créer un nouveau',
      'unknown_save_error': "L'Unknown n'a pas pu être enregistré. Veuillez réessayer.",
      'not_concerned': 'Pas concerné',
      'not_important': 'Pas important',
      'important': 'Important',
      'very_important': 'Très important',
      'critical': 'Critique',
      'not_provided': 'Non fourni',
      'poor': 'Pauvre',
      'fair': 'Equilibré',
      'good': 'Bon',
      'outstanding': 'Exceptionnel',
      'report': 'Rapport',
      'feasibility_study': 'Document d\'opportunité',
      'gantt_chart': 'Gantt chart',
      'tools': 'Outils',
      'review_1_customers': 'Revue 1 : Clients',
      'review_1_customer_fit': 'Revue 1 : Fit Client',
      'review_1_company_fit': 'Revue 1 : Fit Entreprise',
      'do_you_want_to_close_without_saving': 'Voulez-vous fermer la fenêtre sans sauvegarder ?',
      'confirmation_title': 'Confirmation',
      'tutorial': 'Tutoriel',
      'plan': 'Abonnement',
      // Organization
      'organization': 'Organisation',
      'subscription': 'Abonnement',
      'premium_plan': 'Plan Premium',
      'free_plan': 'Plan gratuit',
      'last_update_label': 'Dernière mise à jour',
      'unknowns_count_label': 'Inconnues',
      'actions_count_label': 'Actions',
      'general': 'Général',
      'organization_settings': 'Paramètres de l\'organisation',
      'settings': 'Paramètres',
      'organization_name': 'Nom de l\'organisation',
      'company_size': 'Taille de l\'entreprise',
      // Project
      'project_administration': 'Administration du projet',
      // Account
      'account': 'Compte',
      'projects': 'Projets',
      'reports': 'Rapports',
      'deactivated': 'Désactivés',
      'deactivated_pages': 'Pages qui ont été désactivées',
      'deactivated_fields': 'Champs qui ont été désactivés',
      'deactivate_field': 'Désactiver ce champ',
      'deactivate_page': 'Désactiver cette page',
      'reply': 'Répondre',
      'send': 'Envoyer',
      'add_comment': 'Ajouter un commentaire',
      'no_comments': 'Aucun commentaire',
      'documents_on_this_page': 'Documents de cette page',
      'list_of_uploads_for': 'Liste des uploads pour {{screen}}',
      'documents': 'Documents',
      'uploads': 'Uploads',
      'type': 'Type',
      'file': 'Fichier',
      'no_documents': 'Aucun upload',
      'upload_created': 'Upload créé',
      'url_helper_text': 'Ou collez un lien vers un document externe',
      'invalid_url': 'URL invalide',
      'url': 'URL',
      'estimated_price': 'Prix estimé',
      'alternatives': 'Alternatives',
      'company_alternatives': 'Alternatives de l\'entreprise',
      'milestone_due_date': 'Date d\'échéance du jalon',
      'milestone_definition': 'Définition du jalon',
      'kiss_name': 'Nom de l\'indicateur clé de succès',
      'kiss_unit': 'Unité',
      'kiss_value': 'Valeur de l\'indicateur clé (par jalon)',
      'kif_name': 'Nom de l\'indicateur clé d\'échec',
      'kif_value': 'Valeur de l\'indicateur clé d\'échec (par jalon)',
      'terminators_consequences': 'Conséquences des terminateurs',
      'investors': 'Investisseurs',
      'investor_benefits': 'Bénéfices investisseurs',
      'power_support_map': 'Carte pouvoir / soutien',
      'search_action_name': 'Rechercher le nom de l\'action',
      'view_toggle': 'Basculer la vue',
      'concernings_label': 'Concernés',
      'search_ip_description': 'Rechercher une description de propriété intellectuelle',
      'plan_type_budget': 'Sélection du plan budgétaire',
      'other': 'Autre',
      'reactivate': 'Réactiver',
      'hidden_fields_on_this_page': 'Champs masqués sur cette page',
      'add_tactical_action': '+ Action tactique',
      'select_resistance_actions': 'Sélectionner les actions tactiques',
      'selected_resistance_actions': 'Actions tactiques sélectionnées',
      'no_deactivated_items': 'Aucun élément désactivé pour le moment',
      'field': 'Champ',
      'page': 'Page',
      'overview': 'Vue d\'ensemble',
      'sales': 'Ventes',
      'general_settings': 'Paramètres généraux',
      'notifications': 'Notifications',
      'team': 'Équipe',
      'billing': 'Paiement',
      'pending_invitations': 'Invitations en attente',
      'pending': 'En attente',
      'invited_as': 'Invité en tant que',
      'permissions': 'Permissions',
      'invited_on': 'Invité le',
      'accept': 'Accepter',
      'decline': 'Refuser',
      'no_pending_invitations': 'Aucune invitation en attente',
      'no_pending_invitations_description': 'Vous n\'avez aucune invitation de projet en attente pour le moment.',
      'refresh': 'Actualiser',
      'failed_to_load_pending_invitations': 'Échec du chargement des invitations en attente',
      'invitation_accepted_successfully': 'Invitation acceptée avec succès !',
      'failed_to_accept_invitation': 'Échec de l\'acceptation de l\'invitation',
      'failed_to_process_invitation': 'Échec du traitement de l\'invitation',
      'invitation_declined_successfully': 'Invitation refusée avec succès !',
      'failed_to_decline_invitation': 'Échec du refus de l\'invitation',
      'premium_subscription_required_message': 'Vous avez besoin d\'un abonnement premium pour accepter les invitations de projet. Veuillez mettre à niveau votre plan pour rejoindre des projets.',
      'loading': 'Chargement...',
      'premium_subscription_required_tooltip': 'Abonnement premium requis pour accepter les invitations',
      'editor_full_access': 'Éditeur (accès complet)',
      'viewer_read_only': 'Visualiseur (lecture seule)',
      'restricted_no_admin': 'Restreint (aucun accès aux fonctions admin)',
      'team_member': 'Membre d\'équipe',
      'unknown': 'Inconnu',
      'project': 'Projet',
      'whole_project': 'Projet entier',
      'project_settings': 'Paramètres du projet',
      'project_team': 'Équipe du projet',
      // Review 1
      'review_1': 'Revue 1',
      'customers': 'Clients',
      'company_fit': 'Entreprises & investisseurs',
      'update_customer': 'Mettre à jour le client',
      'create_customer': 'Créer un client',
      'customer_deletion': 'Suppression d\'un client',
      'customer_deletion_message': 'Êtes-vous sûr de vouloir supprimer ce client ?',
      'pnd': 'Douleur / Besoin / Désir',
      'benchmarking': 'Benchmarking',
      'experience': 'Expérience',
      'who_is_the_customer': 'Qui est le client ?',
      'customer_issue_problem': 'Quel est le problème du client ?',
      'price_per_unit': 'Prix par unité',
      'target_market_comments': 'Commentaires sur le marché cible',
      'unit': 'Unité',
      'decision_criteria': 'Critère de décision',
      'importance': 'Importance',
      'focus': 'Focus',
      'criteria_name': 'Nom du critère',
      'elevator_pitch_label': 'Elevator pitch for this customer',
      'cue_statement_label': 'Customer Unique Experience for this customer',
      'cue_statement_hint_label': 'Continue the statement starting with "I/we recommend this ... because it is the only one that ..."',
      'reason_to_buy_label': 'What is the compelling reason for this customer to buy?',
      'estimated_cost_and_price_label': 'Estimated Cost & Price',
      'cue_comments_label': 'Comments about our ability to deliver this Customer Unique Experience (including availability of technical or other capabilities)',
      'pre_con_cue_label': 'What are the prerequisites or conditions required for this CUE to work?',
      'cue_resitances_label': 'Outline all possible Resistances that this customer could raise in response to this CUE statement',
      'market_penetration_strategy_experience_label': 'Special characteristics of the market penetration strategy to reach this customer',
      'wow_label': 'What is the "Wow" for this customer?',
      'selling_price': 'Prix de vente',
      'estimated_cost': 'Coût estimé',
      'profit_margin': 'Marge',
      'benefits': 'Bénéfices',
      'benefits_for_our_company_label': 'Bénéfices pour notre entreprise',
      'brand_essence_compatibility_label': 'Compatibilité avec l\'essence de la marque',
      'concerned_divisions_label': 'Divisions concernés',
      'confidence_indice_label': 'confidence_indice_label',
      'corporate_mission_label': 'Which components of our corporate mission will benefit from seizing this opportunity?',
      'geographical_scope_label': 'Portée géographique',
      'get_results_by_label': 'Résultats avant',
      'kpi_benefit_label': 'Which of our corporate Key Performance Indicators will be improved by seizing this opportunity?',
      'launch_date_label': 'Date de lancement',
      'market_size_label': 'Taille du marché',
      'consequences_on_failure_label': 'Conséquences d\'un arrêt prématuré du projet ou d\'un échec',
      'not_seizing_opportunity_label': 'What will happen if our company does not seize this opportunity?',
      'strategic_fit_label': 'Ajustement stratégique',
      'target_audience_label': 'Audience ciblée',
      'company': 'Entreprise',
      'pre_requisites': 'Pré-requis',
      'client_aspiration': 'Aspiration du client',
      'days_ago': 'day(s) ago',
      'update_company': 'Mettre à jour une entreprise ou une partie prenante',
      'create_company': 'Créer ue entreprise ou une partie prenante',
      // Review 2
      'review_2': 'Revue 2',
      'definition_of_success_and_failure': 'Définition du succès et de l\'échec',
      'milestones': 'Milestones',
      'kiss': 'Indicateurs clés de succès (KISs)',
      'terminators': 'Indicateurs clés d\'échec (Terminators)',
      'activity_chain': 'Chaîne d\'activité',
      'customer_relationships_strategies': 'Special characteristics of the Customer Relationships strategy',
      'marketing_strategies': 'Special characteristics of the Marketing strategy',
      'distribution_strategies': 'Special characteristics of the Distribution strategy',
      'product_development_strategies': 'Special characteristics of the  Product Development strategy',
      'production_strategies': 'Special characteristics of the Production strategy',
      'service_strategies': 'Special characteristics of the Service strategy',
      'ip_strategies': 'Special characteristics of the I.P. strategy',
      'procurement_strategies': 'Special characteristics of the Procurement strategy',
      'infrastructure_strategies': 'Special characteristics of the Service strategy',
      'partnering_strategies': 'Special characteristics of the Partnering strategy',
      'hr_strategies': 'Special characteristics of the H.R. strategy',
      'training_strategies': 'Special characteristics of the Training strategy',
      'financial_strategies': 'Special characteristics of the Financial strategy',
      'change_of_processes_strategies': 'Special characteristics of the change of processes strategy',
      'change_management_strategies': 'Special characteristics of the change management strategy',
      'economic_model': 'Génération des ressources',
      'review_2_economic_model': 'Comment le projet génerera des revenus récurrents ?',
      'kiss_field': 'Kiss',
      'terminator_field': 'Terminator',
      'mechanism': 'Mécanisme',
      'target': 'Cible',
      'what': 'Quoi',
      'comment': 'Commentaire',
      'skills': 'Compétences',
      'benefit': 'Bénéfice',
      // Review 3
      'review_3': 'Revue 3',
      'probability': 'Probabilité',
      'confidence_level': 'Niveau de confiance',
      'opportunity_killer': 'Magnitude',
      'neg_impact': 'Impact négatif',
      'pos_impact': 'Impact positif',
      'pre_move': 'Pre. action',
      'cont_move': 'Cont. action',
      'low': 'Basse',
      'medium': 'Moyenne',
      'high': 'Haute',
      'no': 'Non',
      'yes': 'Oui',
      'preventive_move': 'Preventive action',
      'contigency_move': 'Contengency action',
      'concerning': 'Concerne',
      'update_and_quit': 'Mettre à jour & quitter',
      'add_factor': 'Ajouter un facteur',
      'create_factor': 'Créer un facteur',
      'update_factor': 'Mettre à jour le facteur',
      'add_stakeholder': 'Ajouter une partie prenante',
      'add_investor': 'Ajouter un investisseur',
      'update_stakeholder': 'Mettre à jour la partie prenante',
      // Review 4
      'review_4': 'Revue 4',
      'launch_plan': 'Plan de lancement',
      'reduce_unknowns_plan': 'Plan de réduction des inconnues',
      'intellectual_properties': 'Propriété intellectuelle',
      'moves': 'Actions',
      'add_move': 'Ajouter une action',
      'add_intellectual_property': 'Ajouter une propriété intellectuelle',
      'consultant': 'Consultant',
      'it': 'I.T.',
      // Quick Actions
      // // Unknown
      'create_unknown': 'Créer une inconnue',
      'concerning_id': 'Cela concerne',
      'positive_impact': 'Impact positif',
      'negative_impact': 'Impact négatif',
      'no_go': 'No go',
      'criticality': 'Impact',
      'impact': 'Impact',
      'add_tactical_move': 'Ajouter une action tactique',
      'create_and_quit': 'Créer & quitter',
      'create_and_add_another_one': 'Créer & ajouter un nouveau',
      'collateral_effects': 'Effets collatéraux potentiels',
      'collateral_stakeholder': 'Parties prenantes impactées par cet effet collatéral',
      'collateral_severity': 'Niveau de gravité de cet effet collatéral',
      'resources': 'Ressources',
      'action_plan': 'Plan d\'action',
      'stakeholders': 'Parties prenantes',
      'factors': 'Facteurs',
      'factor_name': 'Nom du facteur',
      'description_of_this_factor': 'Description de ce facteur',
      'scope': 'Scope',
      'company_decision_criteria': 'Critére de décision de l\'entreprise',
      'solution': 'Solution',
      'solution_name': 'Nom de la solution',
      'solution_description': 'Description détaillée de la solution/projet',
      'geographic_scope': 'Portée géographique',
      'proof_of_concept_date': 'Date de preuve de concept',
      'demonstration_date': 'Date de démonstration',
      'pilot_beginning_date': 'Date de début du pilote',
      'pilot_end_date': 'Date de fin du pilote',
      'launch_date': 'Date de lancement',
      'potential_evolution': 'Évolution potentielle',
      'wow_investor_alignment_label': "Quel facteur « Wow » pour cet investisseur",
      'worth_it_investor_alignment_label': "Ce qui rend cette opportunité intéressante pour cet investisseur",
      'estimated_chance_of_success_investor_alignment_label': "Chances de succès estimées pour cet investisseur",
      'strategic_fit_investor_alignment_label': "Adéquation avec la stratégie de cet investisseur",
      'concerned_divisions_investor_alignment_label': "Division(s) concernée(s) pour cet investisseur",
      'potential_synergies_investor_alignment_label': "Synergies potentielles pour cet investisseur",
      'risk_of_canibalization_investor_alignment_label': "Risque de cannibalisation de l'offre de cet investisseur",
      'biggest_challenges_investor_alignment_label': "Plus grands défis pour cet investisseur",
      'constrains_investor_alignment_label': "Contraintes imposées par cet investisseur",
      'brand_essence_compatibility_investor_alignment_label': "Compatibilité avec l'essence de marque de cet investisseur",
      'geographical_scope_investor_alignment_label': "Portée géographique",
      'target_audience_investor_alignment_label': "Public cible",
      'potential_evolution_investor_alignment_label': "Évolution ou expansion potentielle pour cet investisseur",
      'when_poc_investor_alignment_label': "Quand cet investisseur peut voir une preuve de concept",
      'demonstration_be_made_investor_alignment_label': "Quand cet investisseur peut voir une démonstration",
      'customer_benchmarking': 'Benchmarking du client',
      'customer_knowledge': 'Connaissance du client',
      'customer_pnds': 'PNDs du client',
      // // Move
      'create_move': 'Créer une action',
      'essentials': 'Général',
      'more_details': 'Plus de détails',
      'costing': 'Coûts',
      'detailed_impact': 'Détails de l\'impact',
      'selected_for_action_plan': 'Sélectionné pour le plan d\'action',
      'retained_for_action_plan': 'Retenu pour le Plan d\'Action final',
      'selected_for_launch_plan': 'Sélectionné pour le plan de lancement',
      'selected_for_reduce_unknown_plan': 'Sélectionné pour le plan de réduction d\'inconnues',
      'decision_for_action_plan': 'Recommandation pour le plan d\'action',
      'must_be_done': 'Doit être fait',
      'should_be_done': 'Devrait être fait',
      'nice_to_do': 'Bon à faire',
      'not_worth_it': 'N\'en vaut pas la peine',
      'manage_stakeholders': 'Gérer les parties prenantes',
      'fit_company': 'Fit entreprise',
      'reduce_resitances': 'Réduire les résistances',
      'reduce_unknowns': 'Réduire les inconnues',
      'reduce_constraints': 'Réduire les contraintes',
      'reduce_risks': 'Réduire les risques',
      'overcome_obstacles': 'Surmonter les obstacles',
      'benefit_of_boosters': 'Bénéfice du booster',
      'create_barrier_to_entry': 'Crée une barière à l\'entrée',
      'deliver_benefits': 'Délivre un bénéfice',
      'convince_customers': 'Convaincre les clients',
      'increase_market_penetration': 'Augmenter la pénétration du marché',
      'obtain_the_resource': 'Obtenir la ressource',
      'reduce_collateral_effect': 'Réduire les effets collatéraux',
      'support_the_team': 'Supporter l\'équipe',
      'start_date': 'Date de début',
      'end_date': 'Date de fin',
      'user': 'Utilisateur',
      'back': 'Retour',
      'next_step': 'Étape suivante',
      'description_of_the_move': 'Description détaillée de l\'action',
      'action_name': 'Nom de l\'action',
      'comment_about_action': 'Commentaire sur l\'action',
      'collateral_effects_action': 'Effets collatéraux déclenchés par cette action',
      'estimated_total_cost_action': 'Coût total estimé de cette action',
      'move_details': 'Costing de cette action',
      'kpi': 'Indicateurs clé de performance (KPI)',
      'goal_date': 'Date d\'objectif',
      'description_of_the_goal': 'Description de l\'objectif',
      'units': 'Unités',
      'amount_per_unit': 'Coût / unité',
      'workingCapital': 'Working capital',
      'equipmentCost': 'Coût de l\'équipement',
      'consultants': 'Consultants fees',
      'subcontractors': 'Subcontractors Remuneration',
      'travelExpenses': 'Dépenses de voyage',
      'seniorManagement': 'Management senior',
      'intermediateManagement': 'Management intermédiaire',
      'engineering': 'Ingénierie',
      'admin': 'Admin',
      'production': 'Production',
      'space': 'Espace',
      'total': 'Total',
      'definition_of_success': 'Définition du succès',
      'definition_of_failure': "Définition de l'échec",
      'client_decision_criteria': 'Critère de décision du client',
      'unknowns': 'Inconnues',
      'list_of_unknowns': 'Liste des Inconnues',
      'obstacles': 'Obstacles',
      'risks': 'Risques',
      'boosters': 'Boosters',
      'constraints': 'Contraintes',
      'resistances': 'Résistances',
      'aspirations': 'Douleur/Besoin/Désir(s) (= Aspiration(s))',
      'all_steps_completed': 'Toutes les étapes sont complétées !',
      'pilot_details': 'Details of the Pilot',
      'pilot_expected_outcomes': 'Expected Outcomes of this Pilot',
      'pilot_start_date': 'Start Date of the Pilot',
      'pilot_end_date_label': 'End Date of the Pilot',
      'investor_benefits_tab': 'Single Investor Benefits',
      'all_benefits_tab': 'All Benefits',
      'investor_benchmarking_tab': 'Investor Benchmarking',
      'add_milestone_tooltip': 'Add new milestone',
      'add_unknown': 'Ajouter une inconnue',
      // // IP
      'create_intellectual_property': 'Créer une propriété intellectuelle',
      'unique_feature': 'Fonctionnalité unique',
      'current_best_mode': 'Meilleur mode actuel',
      'persons': 'Personnes',
      'prior_art_description': 'Prior art description',
      'closest_publication': 'Closest publication',
      // // Comment
      'create_comment': 'Créer un commentaire',
      'update_comment': 'Modifier le commentaire',
      'comment_created': 'Commentaire créé',
      'comment_updated': 'Commentaire mis à jour',
      'message': 'Message',
      'share_with_team': 'Partager avec l\'équipe',
      'upload_private_label': 'Upload privé pour moi',
      'upload_shared_label': "Upload partagé avec l'équipe du projet",
      'private': 'Privé',
      'shared': 'Partagé',
      'shared_private': 'Partagé / Privé',
      'comment_filter_all': 'Tous',
      'comment_filter_private': 'Privés',
      'comment_filter_shared': 'Partagés',
      'comments': 'Commentaires',
      'link': 'Lien',
      // // Document
      'add_file_or_url': 'Ajouter un fichier ou une URL',
      'upload_file_or_url': 'Téléverser un fichier ou une URL',
      'name_of_upload': "Nom de l'upload",
      'description_of_upload': "Description de l'upload",
      'title': 'Titre',
      // // Stakeholders
      'create_stakeholder': 'Créer une partie prenante',
      'profile': 'Profil',
      'lever': 'Aspirations/Résistances',
      'stakeholder_name': 'Nom de la partie prenante',
      'influencing': 'Influences',
      'level_of_power': 'Niveau de pouvoir',
      'level_of_support': 'Niveau de support',
      'level_of_support_of_this_stakeholder': 'Niveau de support de cette partie prenante',
      'level_of_support_info': 'Dans quelle mesure cette partie prenante soutient le projet. Utilisez le bouton ci-dessous pour indiquer si ce niveau a été vérifié.',
      'level_of_support_verified_switch': 'Le niveau de support a été vérifié',
      'how_impacted': 'Comment impacte-t-il ?',
      'how_impacted_by_project': 'Comment cette partie prenante est impactée par ce projet',
      'stakeholder_collateral_damages': 'Dommage(s) collatéral(aux) que cette partie prenante pourrait subir',
      'influencing_who': 'Influence qui ?',
      'influencing_by': 'Influencé par ?',
      // Logs
      'customer_pnd': 'PND',
      'customer_experience': 'Expérience',
      'company_benefits': 'Bénéfices',
      // Reports
      'feasibility_studies': 'Dossiers d\'opportunités',
      'export_print': 'Exporter / Imprimer',
      'view_report': 'Afficher le rapport',
      'download': 'Télécharger',
      'export_all_uploads': 'Tout exporter',
      'gantt_charts': 'Gantt charts',
      'create_new_version': 'Créer une nouvelle version',
      // LABELS
      'concerning_label': 'Concerné',
      'reduced_by': 'Action pour réduire',
      'probability_label': 'prob.',
      'move_description': 'Description',
      'Tactical Actions to reduce this Unknown': 'Actions tactiques pour réduire cette Inconnue',
      'No actions selected': 'Aucune action sélectionnée',
      'Result of Action to reduce Unknown (what has been learned)': 'Résultat de l\'Action pour réduire l\'Inconnue (ce qui a été appris)',
      'Select Contingency Actions': 'Sélectionner les Actions de Contingence',
      'Selected Contingency Actions': 'Actions de Contingence Sélectionnées',
      'Select Preventive Actions': 'Sélectionner les Actions Préventives',
      'Selected Preventive Actions': 'Actions Préventives Sélectionnées',
      'Select Booster Actions': 'Sélectionner les Actions de Levier',
      'Selected Booster Actions': 'Actions de Levier Sélectionnées',
      'Actions to Prevent this Risk from Happening': 'Actions pour Empêcher ce Risque de se Produire',
      'Actions Addressing Risk when it Materializes': 'Actions pour Traiter le Risque lorsqu\'il se Concrétise',
      'Actions to Take Advantage of a Booster (Positive Factor)': 'Actions pour Tirer Parti d\'un Levier (Facteur Positif)',
      'No preventive actions selected': 'Aucune action préventive sélectionnée',
      'No contingency actions selected': 'Aucune action de contingence sélectionnée',
      'No booster actions selected': 'Aucune action de levier sélectionnée',
      'Search actions...': 'Rechercher des actions...',
      'Select Related Actions': 'Sélectionner les Actions Liées',
      'Selected actions': 'Actions sélectionnées',
      'Choose existing actions that are related to this unknown. You can search by name, description, or comments.': 'Choisissez les actions existantes qui sont liées à cette inconnue. Vous pouvez rechercher par nom, description ou commentaires.',
      'edit_team_member': 'Modifier un membre de l\'équipe',
      'member_permissions_updated_successfully': 'Permissions du membre mises à jour avec succès',
      'failed_to_update_member_permissions': 'Échec de la mise à jour des permissions du membre',
      'invite_team_member': 'Inviter un membre de l\'équipe',
      'invitation_sent_successfully': 'Invitation envoyée avec succès',
      'failed_to_send_invitation': 'Échec de l\'envoi de l\'invitation',
      'premium_subscription_required_invite': 'Un abonnement premium est requis pour inviter des membres d\'équipe. Veuillez mettre à niveau votre plan.',
      'premium_subscription_required_send': 'Un abonnement premium est requis pour envoyer des invitations. Veuillez mettre à niveau votre plan.',
      'synthesis': 'Synthèse',
      'screen': 'Écran',
      'comment_title': 'Titre du commentaire',
      'author': 'Auteur',
      'date': 'Date',
      'importance_not': 'Pas important',
      'importance_important': 'Important',
      'importance_very': 'Très important',
      'status': 'Statut',
      'open': 'Ouvert',
      'completed': 'Terminé',
      'mark_completed': 'Archiver ce commentaire',
      'mark_open': 'Rendre actuel',
      'current_comments': 'Commentaires actuels',
      'archive_comment': 'Archiver ce commentaire',
      'unarchive_comment': 'Rendre actuel',
      'comment_status_current': 'Actuels',
      'comment_status_archived': 'Archivés',
      'comment_share_my_private': 'Mes commentaires privés',
      'comment_share_shared': 'Commentaires partagés',
      'comment_url_label': 'Collez un lien optionnel vers un site/une page ou un document externe',
      'comment_private_label': 'Commentaire privé pour moi',
      'comment_shared_label': 'Commentaire partagé avec l\'équipe du projet',
      'nested': 'Imbriqué',
      'conversation': 'Conversation',
      'all': 'Tout',
      'not_assessed': 'Non évalué',
      'respondent': 'Répondant',
      'validation_sent_title': 'Demande de validation envoyée',
      'validation_anti_spam_notice': 'Votre demande de validation a été envoyée. Pour éviter qu\'elle soit considérée comme du spam, prévenez vos validateurs qu\'une demande légitime proviendra de No-reply@ipoptools.com. Vous pouvez aussi leur transférer votre propre copie pour qu\'ils l\'attendent.',
      'ok': 'OK',
      'failed_to_send_invitation_email': 'Échec de l\'envoi de l\'email d\'invitation. Veuillez vérifier l\'adresse email et réessayer.',
      'you_need_premium_subscription': 'Vous avez besoin d\'un abonnement premium pour inviter des membres d\'équipe à vos projets. Veuillez mettre à niveau votre plan pour activer les fonctionnalités de collaboration d\'équipe.',
      'upgrade_subscription': 'Mettre à niveau l\'abonnement',
      'upgrade_now': 'Passer à Premium',
      'subscription_limit_reached': 'Limite du plan gratuit atteinte : maximum {{limit}} éléments. Passez à Premium pour un accès illimité.',
      'must_be_valid_email': 'Doit être un email valide',
      'email_is_required': 'L\'email est requis',
      'active': 'Actif',
      'waiting': 'En attente',
      'rejected': 'Rejeté',
      'deleted': 'Supprimé',
      'required': 'Requis',
      // Company — Fournisseur IA (clé API LLM de l'entreprise)
      'company_llm_section_title': 'Fournisseur IA',
      'company_llm_intro': 'Faites tourner les fonctionnalités IA sur votre propre compte Anthropic ou OpenAI plutôt que sur le nôtre. Votre fournisseur vous facture directement l\'usage.',
      'company_llm_default_notice': 'Aucun fournisseur actif : les fonctionnalités IA utilisent notre clé et consomment vos crédits IA inclus.',
      'company_llm_anthropic_key': 'Clé API Anthropic',
      'company_llm_openai_key': 'Clé API OpenAI',
      'company_llm_key_helper': 'Laissez vide pour conserver la clé enregistrée. Une clé enregistrée n\'est plus jamais affichée.',
      'company_llm_key_configured': 'Clé enregistrée',
      'company_llm_key_not_configured': 'Aucune clé enregistrée',
      'company_llm_use_anthropic': 'Utiliser notre compte Anthropic',
      'company_llm_use_openai': 'Utiliser notre compte OpenAI',
      'company_llm_exclusive_hint': 'Un seul fournisseur peut être actif à la fois — activer l\'un désactive l\'autre.',
      'company_llm_enable_needs_key': 'Enregistrez d\'abord une clé pour activer ce fournisseur.',
      'company_llm_save': 'Enregistrer le fournisseur IA',
      'company_llm_saved': 'Réglages du fournisseur IA enregistrés',
      'company_llm_save_error': 'Impossible d\'enregistrer les réglages du fournisseur IA. Veuillez réessayer.',
      'company_llm_no_company': 'Enregistrez d\'abord les informations de votre entreprise pour configurer un fournisseur IA.',
      // Assistant chat widget — affiché à la place du solde de crédits
      'chat_own_api_key': 'Clé API custom',
    }
  }
};

export const initializeI18n = (lng: string): void => {
  i18n
    .use(initReactI18next)
    .init({
      resources,
      lng,
      fallbackLng: 'en',
      // The app uses a single flat translation table (no namespaces), and some
      // labels contain ':' (e.g. "IpOp Review 1: Is there hope?") which i18next
      // would otherwise treat as a namespace separator and truncate. Disable it
      // so such strings render in full.
      nsSeparator: false,
      interpolation: {
        escapeValue: false
      }
    });
};
